import { useTranslation } from 'react-i18next';

import Product from 'components/product/Product';
import {getData} from 'components/product/util';

import img1 from 'assets/images/solutions/inverters/qc/inverter_1.jpg'
import img2 from 'assets/images/solutions/inverters/qc/inverter_2.png'
import img3 from 'assets/images/solutions/inverters/qc/inverter_3.png'

export default function ProductQc(){
  const {t} = useTranslation();
  const products = getData(t, "inverters", "qc");
 
  // 그림 이름은 대중이 없어서 따로 넣어야 함.
  products[0].images = [img1];
  products[1].images = [img2];
  //products[2].images = [img3];

  return (
    <Product products={products}/>
  );
}